import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=b44a82a2&scoped=true&"
import script from "./AppHeader.vue?vue&type=script&lang=ts&"
export * from "./AppHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AppHeader.vue?vue&type=style&index=0&id=b44a82a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44a82a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b44a82a2')) {
      api.createRecord('b44a82a2', component.options)
    } else {
      api.reload('b44a82a2', component.options)
    }
    module.hot.accept("./AppHeader.vue?vue&type=template&id=b44a82a2&scoped=true&", function () {
      api.rerender('b44a82a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppContainer/AppHeader.vue"
export default component.exports